import apiClient from './apiClient';

export const getPromotions = (params) => {
    return apiClient.get('/promotion', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
};

export const createPromotion = (data) => {
    return apiClient.post('/promotion', data);
  };
  
  export const updatePromotion = (id, data) => {
    return apiClient.put(`/promotion/${id}`, data);
  };
  
  export const deletePromotion = (id) => {
    return apiClient.delete(`/promotion/${id}`);
  };

  
  export const getPromotionList = (params) => {
    return apiClient.get('/promotion/list', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
  };

  export const updatePromotionList = (id, data) => {
    return apiClient.put(`/promotion/list/${id}`, data);
  };
